import Pacman from "src/app/components/layout/Pacman";
import { useOffSiteStats } from "src/app/hooks";
import { UserModel } from "src/app/types/UserModel";
import OffSiteStat from "./OffSiteStat";
import { toAbsoluteUrl } from "src/_metronic/helpers";
import SVG from "react-inlinesvg";
import { useIntl } from "react-intl";
import OffSiteButtonsContainer from "../OffSiteButtons/OffSiteButtonsContainer";
import { useAuth } from "src/app/utils/useAuth";
import { UserRole } from "src/app/transports/user";

const OffSiteStatsContainer = (props: {
    moneySiteId?: number;
    selectedRows?: Array<any>;
    isVisible: boolean;
}) => {
    const { moneySiteId, selectedRows, isVisible } = props;
    const { formatMessage } = useIntl();
    const intl = useIntl();

    const { currentUser } = useAuth();

    const { offSiteStats, loading } = useOffSiteStats(moneySiteId);

    const hasAccess =
        currentUser.email === "neoseo.admin.active.1@yopmail.com" ||
        currentUser.email === "infra@1ercontact.fr";

    if (loading) return <Pacman />;

    return (
        <div className={`offSiteWrapper ${isVisible ? "" : "d-none"}`}>
            <div
                className={` d-flex flex-column justify-content-between ms-4 ${
                    isVisible ? "" : ""
                }`}
            >
                <div className="d-flex flex-row gap-2">
                    <div>
                        {offSiteStats?.site?.pbn?.name} {offSiteStats?.site?.thematic?.name}
                    </div>
                </div>

                <div>
                    <div>
                        <SVG
                            width={16}
                            src={toAbsoluteUrl(
                                `/media/flags/${offSiteStats?.site?.lang?.toLowerCase()}.svg`
                            )}
                        />{" "}
                        {formatMessage({ id: "common.site.manager" })} :
                    </div>
                    <ul>
                        {offSiteStats?.site?.managers[0]
                            ? offSiteStats?.site?.managers.map((el: UserModel, index: number) => (
                                  <li key={index}>{el.name}</li>
                              ))
                            : "Aucun"}
                    </ul>
                </div>

                <div>
                    <div className="d-flex flex-row gap-2">
                        <div>{formatMessage({ id: "common.site.device.desktop" })} :</div>
                        <span>
                            <a href={offSiteStats?.site.url_report_desktop} target="_blank">
                                {offSiteStats?.site?.performance_score_desktop || 0}
                                {" %"}
                            </a>
                        </span>
                    </div>
                    <div className="d-flex flex-row gap-2">
                        <div>{formatMessage({ id: "common.site.device.mobile" })} :</div>
                        <span>
                            <a href={offSiteStats?.site.url_report_mobile} target="_blank">
                                {offSiteStats?.site?.performance_score_mobile || 0}
                                {" %"}
                            </a>
                        </span>
                    </div>
                </div>
                <div>
                    <div className="d-flex flex-row gap-2">
                        <div>{formatMessage({ id: "common.site.monitoring.days" })} :</div>
                    </div>

                    <div className="statusCakeWrapper">
                        {offSiteStats?.site.status_cake_id && (
                            <img
                                src={`https://app.statuscake.com/button/index.php?Track=${offSiteStats?.site.status_cake_id}&Days=30&Design=2`}
                                style={{ width: "150px" }}
                            />
                        )}
                    </div>
                </div>
            </div>
            <div className="divider" />

            <>
                <OffSiteStat
                    stat={offSiteStats?.traffic}
                    statName={intl.formatMessage({ id: "offsite.stats.traffic" })}
                />
                <div className="divider dim" />
                <OffSiteStat
                    stat={offSiteStats?.keywords}
                    statName={intl.formatMessage({ id: "offsite.stats.keyword" })}
                />
                <div className="divider dim" />
                <OffSiteStat
                    stat={offSiteStats?.rd}
                    statName={intl.formatMessage({ id: "offsite.stats.rd" })}
                />
                <div className="divider" />
                {currentUser?.role == UserRole.ROLE_ADMIN && (
                    <>
                        <OffSiteStat
                            stat={offSiteStats?.po}
                            statName={intl.formatMessage({ id: "offsite.stats.po" })}
                        />
                        <div className="divider dim" />

                        <OffSiteStat
                            stat={offSiteStats?.sell}
                            statName={intl.formatMessage({ id: "offsite.stats.sell" })}
                        />
                        <div className="divider dim" />
                        <OffSiteStat
                            stat={offSiteStats?.average}
                            statName={intl.formatMessage({ id: "offsite.stats.average" })}
                        />

                        <div className="divider" />
                    </>
                )}

                <OffSiteStat
                    stat={offSiteStats?.netlinking}
                    statName={intl.formatMessage({ id: "offsite.stats.netlinking" })}
                />
                <div className="divider dim" />
                <OffSiteStat
                    stat={offSiteStats?.writing}
                    statName={formatMessage({ id: "offSite.statName.writing" })}
                />
                <div className="divider" />

                <OffSiteButtonsContainer
                    selectedRows={selectedRows}
                    hasAccess={hasAccess}
                    moneySiteId={moneySiteId}
                />
            </>

            <div style={{ width: "180px" }} className="stats mx-auto">
                {offSiteStats?.site?.domain && (
                    <a
                        style={{ height: "100%" }}
                        href={`https://s3.eu-west-1.amazonaws.com/files.digitent.co/sites/${offSiteStats?.site?.domain}.webp`}
                        target="_blank"
                    >
                        <div
                            className="image "
                            style={{
                                backgroundImage: `url(https://s3.eu-west-1.amazonaws.com/files.digitent.co/sites/${offSiteStats?.site?.domain}.webp)`,
                            }}
                        />
                    </a>
                )}
            </div>
        </div>
    );
};

export default OffSiteStatsContainer;
